import {
  FB_CASES_INIT,
  FB_CASE_ACCEPT,
  FB_CASE_START_PROCESS,
  FB_CASE_UPDATE_PROGRESS,
  FB_CASE_RESPOND,
  FB_CASE_REASSIGN,
  FB_CASE_CHANGE_PRIORITY,
} from "../action/types";
import { buildAddTimeline } from "../action/feedbackCases";

const PRIORITY_MAP = {
  low: { label: "Thấp" },
  medium: { label: "Trung bình" },
  high: { label: "Cao" },
  urgent: { label: "Khẩn cấp" },
};

const initialState = {
  cases: [],
};

const feedbackCasesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FB_CASES_INIT:
      return { ...state, cases: payload };

    case FB_CASE_ACCEPT:
      return {
        ...state,
        cases: buildAddTimeline(
          state.cases.map((c) =>
            c.id === payload.id
              ? { ...c, status: "accepted", acceptedAt: payload.at }
              : c,
          ),
          payload.id,
          {
            ts: payload.at,
            actor: payload.officerName,
            action: "Đã tiếp nhận vụ việc",
            kind: "accept",
          },
        ),
      };

    case FB_CASE_START_PROCESS:
      return {
        ...state,
        cases: buildAddTimeline(
          state.cases.map((c) =>
            c.id === payload.id ? { ...c, status: "processing" } : c,
          ),
          payload.id,
          {
            ts: payload.at,
            actor: payload.officerName,
            action: "Bắt đầu xử lý vụ việc",
            kind: "process",
          },
        ),
      };

    case FB_CASE_UPDATE_PROGRESS:
      return {
        ...state,
        cases: buildAddTimeline(state.cases, payload.id, {
          ts: payload.at,
          actor: payload.officerName,
          action: "Cập nhật tiến độ",
          kind: "update",
          note: payload.note,
        }),
      };

    case FB_CASE_RESPOND:
      return {
        ...state,
        cases: buildAddTimeline(
          state.cases.map((c) =>
            c.id === payload.id ? { ...c, status: "responded" } : c,
          ),
          payload.id,
          {
            ts: payload.at,
            actor: payload.officerName,
            action: "Đã hoàn thành & gửi phản hồi cho công dân",
            kind: "respond",
            note: payload.responseContent,
          },
        ),
      };

    case FB_CASE_REASSIGN: {
      const { id, values, newOfficer, currentOfficerName, at } = payload;
      return {
        ...state,
        cases: buildAddTimeline(
          state.cases.map((c) =>
            c.id === id
              ? {
                  ...c,
                  assignedOfficer: newOfficer.name,
                  officerRole: newOfficer.role,
                  area: newOfficer.area,
                  status: "pending_accept",
                  acceptedAt: undefined,
                }
              : c,
          ),
          id,
          {
            ts: at,
            actor: currentOfficerName,
            action: `Chuyển tiếp tới ${newOfficer.name}`,
            kind: "reassign",
            note: values.reason,
          },
        ),
      };
    }

    case FB_CASE_CHANGE_PRIORITY: {
      const { id, values, currentCase, officerName, at } = payload;
      const previousLabel = `${PRIORITY_MAP[currentCase.priority]?.label || currentCase.priority} (${
        currentCase.prioritySource.type === "auto" ? "tự động" : "cán bộ"
      })`;
      const nextLabel = `${PRIORITY_MAP[values.priority]?.label || values.priority} (cán bộ)`;
      return {
        ...state,
        cases: buildAddTimeline(
          state.cases.map((c) =>
            c.id === id
              ? {
                  ...c,
                  priority: values.priority,
                  prioritySource: { type: "officer", by: officerName, at },
                }
              : c,
          ),
          id,
          {
            ts: at,
            actor: officerName,
            action: `Điều chỉnh mức độ: ${previousLabel} → ${nextLabel}`,
            kind: "priority",
            note: values.reason,
          },
        ),
      };
    }

    default:
      return state;
  }
};

export default feedbackCasesReducer;
